<template>
  <v-autocomplete
      :error-messages="error"
      variant="outlined"
      rounded="0"
      :label="translation(translationList.house_insured_sum_type, 'Tip sumă asigurată')"
      :items="insuredSumTypes"
      item-title="name"
      item-value="id"
      name="insured_sum_type"
      :loading="loading"
      :disabled="loading"
      v-model="selectedInsuredSumType"
      :rules="[v => !!v || translation(translationList.required, 'Acest câmp este obligatoriu')]"
      return-object
  >
  </v-autocomplete>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, toRefs, watch } from 'vue';
import { useHouseStore } from '~/plugins/store/house';
import { useTranslationStore, translation } from '~/plugins/store/translations';
import type { InsuredSumType } from '~/types/House';
import type {TranslationList} from "~/types/Utils";

export default defineComponent({
  props: {
    modelValue: {
      type: Object as () => InsuredSumType | null,
      default: () => null,
      required: false
    },
  },
  emits: ['update:modelValue', 'validation-house-status'],
  setup(props, { emit }) {
    const { modelValue } = toRefs(props);
    const houseStore = useHouseStore();
    const translationStore = useTranslationStore();
    const selectedInsuredSumType = ref(modelValue.value ? modelValue.value : null);
    const insuredSumTypes = ref<InsuredSumType[]>([]);
    const translationList = ref<TranslationList>({});
    const loading = ref(false);
    const error = ref<string[]>([]);

    onMounted(async () => {
      loading.value = true;
      insuredSumTypes.value = await houseStore.getInsuredSumTypeList();
      translationList.value = await translationStore.getTranslations('ro', 'dashboard');
      loading.value = false;
      const isValid = !!selectedInsuredSumType.value;
      emit('validation-house-status', { field: 'insured_sum_type', isValid });

      // Listen for validate event
      window.addEventListener('validate-house', (data) => {
        if (data.detail && data.detail === 'insured_sum_type') {
          if (!selectedInsuredSumType.value) {
            error.value.push(translation(translationList.value.required, 'Acest câmp este obligatoriu'));
          } else {
            error.value = [];
            emit('validation-house-status', { field: 'insured_sum_type', isValid: true });
          }
        }
      });
    });

    watch(selectedInsuredSumType, (newValue) => {
      emit('update:modelValue', newValue);
    });

    watch(modelValue, (newValue) => {
      if (newValue && (newValue.id !== selectedInsuredSumType.value?.id)) {
        selectedInsuredSumType.value = newValue;
        error.value = [];
      }
      const isValid = !!newValue;
      emit('validation-house-status', { field: 'insured_sum_type', isValid });
    });

    return {
      selectedInsuredSumType,
      translationList,
      translation,
      insuredSumTypes,
      loading,
      error,
    };
  },
});
</script>